module.exports = __webpack_public_path__ + "d88e06f84a1a507d0745ddb3e52a44e8.jpg";